/**
 * @velyn-custom BEGIN — vely-product-rating.js
 * Re-skins REVIEWS.io's live "Rating Snippet" (data_source: reviews_io in
 * snippets/vely-product-rating.liquid) with this theme's own star SVG markup
 * and typography — so the card/PDP rating shows REVIEWS.io's real live
 * number, but always looks like the manual/metafield mode (same classes,
 * same CSS in assets/vely-product-rating.css).
 *
 * REVIEWS.io's own script writes the result onto the hidden
 * [data-vely-reviewsio-source] mount (title="4.89 Stars - 36 Reviews",
 * data-done="true") once it has fetched that product's data — this only
 * parses that attribute, it never talks to REVIEWS.io's API directly.
 */
(function () {
  var STAR_PATH =
    "M14.3719 7.07477L10.9621 9.55205L12.2647 13.5605C12.3352 13.7775 12.2577 14.0152 12.0735 14.1495C11.9808 14.2165 11.8724 14.25 11.7636 14.25C11.6549 14.25 11.5462 14.2165 11.4543 14.1495L8.04463 11.672L4.63517 14.1491C4.45021 14.2835 4.20029 14.2835 4.01572 14.1491C3.83157 14.0152 3.75402 13.7775 3.8246 13.5605L5.12684 9.55188L1.71737 7.07477C1.53277 6.94062 1.45523 6.70306 1.52581 6.48596C1.59656 6.26889 1.79902 6.12202 2.02698 6.12202H6.24143L7.54367 2.11386C7.61424 1.89682 7.81655 1.75 8.04484 1.75C8.27312 1.75 8.47508 1.89682 8.54557 2.11386L9.84781 6.12202H14.0626C14.2905 6.12202 14.4929 6.26892 14.5637 6.48596C14.6337 6.70306 14.556 6.94062 14.3719 7.07477Z";

  function buildStarsHtml(ratingValue) {
    var html = "";
    for (var i = 1; i <= 5; i++) {
      var remaining = ratingValue - (i - 1);
      var fillPct = 0;
      if (remaining >= 1) {
        fillPct = 100;
      } else if (remaining > 0) {
        fillPct = Math.round(remaining * 100);
      }
      html +=
        '<span class="product-rating__star" style="--star-fill: ' +
        fillPct +
        '%;">' +
        '<svg class="product-rating__star-base" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="' +
        STAR_PATH +
        '" fill="#E5E5E5"/></svg>' +
        '<span class="product-rating__star-fill"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="' +
        STAR_PATH +
        '" fill="#E9BD2D"/></svg></span>' +
        "</span>";
    }
    return html;
  }

  function formatAverage(ratingValue, context) {
    var rounded = Math.round(ratingValue * 100) / 100;
    var whole = Math.round(rounded);
    var label = rounded === whole ? whole : rounded;
    if (context === "card") {
      return label === 5 ? String(label) : label + "/5";
    }
    return String(rounded);
  }

  function parseReviewsIoText(text) {
    // REVIEWS.io title/aria-label format: "4.89 Stars - 36 Reviews"
    var match = /([\d.]+)\s*Stars?\s*-\s*(\d+)\s*Reviews?/i.exec(text || "");
    if (!match) return null;
    var rating = parseFloat(match[1]);
    var count = parseInt(match[2], 10);
    if (!isFinite(rating) || !isFinite(count)) return null;
    return { rating: rating, count: count };
  }

  function render(host, parsed) {
    var context = host.getAttribute("data-reviews-io-context") || "pdp";
    var starsEl = host.querySelector("[data-vely-reviewsio-stars]");
    var averageEl = host.querySelector("[data-vely-reviewsio-average]");
    var countEl = host.querySelector("[data-vely-reviewsio-count]");

    if (parsed && parsed.count > 0) {
      if (starsEl) starsEl.innerHTML = buildStarsHtml(parsed.rating);
      if (averageEl) averageEl.textContent = formatAverage(parsed.rating, context);
      if (countEl) {
        var template = countEl.getAttribute("data-reviews-count-template") || "";
        countEl.textContent = template.replace("%%COUNT%%", String(parsed.count));
        countEl.hidden = false;
      }
      host.setAttribute(
        "aria-label",
        parsed.rating + " out of 5 stars, " + parsed.count + " reviews"
      );
      host.classList.add("reviews-io-loaded");
    } else if (countEl) {
      // No reviews yet (or REVIEWS.io reported nothing parseable) — card
      // context has no countEl at all, so it correctly stays hidden here.
      countEl.textContent = countEl.getAttribute("data-empty-label") || "";
      countEl.classList.add("product-rating__count--empty");
      countEl.hidden = false;
      host.classList.add("reviews-io-loaded");
    }
  }

  function tryRead(host, source) {
    if (source.getAttribute("data-done") !== "true") return false;
    var parsed = parseReviewsIoText(
      source.getAttribute("title") || source.getAttribute("aria-label")
    );
    render(host, parsed);
    return true;
  }

  function watch(host) {
    if (host._velyReviewsioBound) return;
    host._velyReviewsioBound = true;

    var source = host.querySelector("[data-vely-reviewsio-source]");
    if (!source) return;
    if (tryRead(host, source)) return;

    var observer = new MutationObserver(function () {
      if (tryRead(host, source)) observer.disconnect();
    });
    observer.observe(source, {
      attributes: true,
      attributeFilter: ["data-done", "title", "aria-label"],
      childList: true,
    });
  }

  function init(root) {
    (root || document)
      .querySelectorAll(".product-rating--reviews-io[data-vely-product-rating]")
      .forEach(watch);
  }

  function bootObserveNewCards() {
    // Covers infinite-scroll/"load more" collection grids and quick-view/AJAX
    // content, where new .product-rating--reviews-io cards are appended after
    // the initial page load without a shopify:section:load event.
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(".product-rating--reviews-io[data-vely-product-rating]")) {
            watch(node);
          }
          if (node.querySelectorAll) init(node);
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
      bootObserveNewCards();
    });
  } else {
    init();
    bootObserveNewCards();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
/* @velyn-custom END — vely-product-rating.js */
